import React, { useState } from "react";
import Close from "../assets/close-circle.svg";
import ZoomedImagePopup from "./ZoomedImagePopup";
import Loader from "./Loader";

interface ImageComparisonProps {
  actualImage: any;
  processedImage?: string | null;
  comparisonImage?: string | null;
  imageType?: any | null;
  loadingPopup?: any | null;
  onClose: () => void;
}

const PlanogramPopup: React.FC<ImageComparisonProps> = ({
  actualImage,
  processedImage,
  imageType,
  loadingPopup,
  onClose
}) => {
  const [isZoomedIn, setIsZoomedIn] = useState(false);
  const [imageToZoom, setImageToZoom] = useState<string | null>(null);

  const openZoomedImage = (imageUrl: string) => {
    setIsZoomedIn(true);
    setImageToZoom(imageUrl);
  };

  const closeZoomedImage = () => {
    setIsZoomedIn(false);
    setImageToZoom(null);
  };

  const isComparison = processedImage && processedImage !== "";

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg p-12 w-full max-w-[1100px]  h-full md:h-[700px] overflow-auto md:overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center pb-6 border-b">
          <h2 className="text-20 font-bold">
            {isComparison ? "Image Comparison" : "Image Viewer"}
          </h2>
          <button className="text-3xl font-bold" onClick={onClose}>
            <img src={Close} alt="Close" />
          </button>
        </div>

        <div className="py-4">
          <h3 className="mb-2 text-16 font-bold text-left">
            Image Type: {imageType}
          </h3>
        </div>

        <div className={`flex gap-6 w-full ${isComparison ? "flex-col md:flex-row" : "justify-center"}`}>
          {/* Actual Image */}
          <div className="text-center flex-1 w-full">
            <h3 className="mb-4 text-16 font-bold text-left">
              {isComparison ? "Actual Image :" : "Document Image :"}
            </h3>
            <div className="relative h-[470px]">
              {loadingPopup && <Loader />}
              {!loadingPopup && <img
                src={actualImage}
                alt="Actual"
                className="w-full object-cover bg-gray-300 rounded-lg cursor-pointer h-full"
                onClick={() => openZoomedImage(actualImage)}
              />}

            </div>
          </div>

          {/* Processed Image (optional) */}
          {isComparison && (
            <div className="text-center flex-1 w-full">
              <h3 className="mb-4 text-16 font-bold text-left">Processed Image :</h3>
              <div className="relative h-[470px]">
                {loadingPopup && <Loader />}
                {!loadingPopup &&
                  <img
                    src={processedImage}
                    alt="Processed"
                    className="w-full object-cover bg-gray-300 rounded-lg cursor-pointer h-full"
                    onClick={() => openZoomedImage(processedImage)}
                  />
                }
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Zoomed Image Overlay */}
      {isZoomedIn && imageToZoom && (
        <ZoomedImagePopup imageUrl={imageToZoom} onClose={closeZoomedImage} />
      )}
    </div>
  );
};

export default PlanogramPopup;
